
import "./success.css";

function Cancel() {
  return (
    <div className="invoice-wrapper">
      <div className="invoice">
        <div className="invoice-header">
          <img
            src="https://www.vyavsay.in/websiteFilesFolder/img/logo.png"
            alt="Company Logo"
            className="invoice-logo"
          />
          <h1>Payment Cancelled</h1>
          <p className="invoice-success">Payment has been cancelled.</p>
        </div>

        

        <div className="invoice-footer">
          <p>Need help? Contact support at support@vyavsay.in</p>
        </div>
      </div>
    </div>
  );
}

export default Cancel;